export const location = {
  SRP: 'SRP',
  NO_RESULTS: 'Zero Result Page',
};
